import React from "react";

export default function CoinCardSkeleton() {
  return (
    <div className="card-coin p-4" data-testid="coin-card-skeleton">
      <div className="flex items-center gap-3">
        <div className="skeleton w-[52px] h-[52px] rounded-xl shrink-0" />
        <div className="min-w-0 flex-1 space-y-2">
          <div className="skeleton h-3.5 w-2/3" />
          <div className="skeleton h-2.5 w-1/2" />
        </div>
      </div>
      <div className="mt-3 space-y-2">
        <div className="skeleton h-2.5 w-full" />
        <div className="skeleton h-2.5 w-4/5" />
      </div>
      <div className="flex items-end justify-between mt-4 mb-3.5">
        <div className="space-y-1.5">
          <div className="skeleton h-2 w-14" />
          <div className="skeleton h-4 w-20" />
        </div>
        <div className="skeleton h-3 w-12 self-end" />
      </div>
      <div className="skeleton h-2 w-full rounded-full" />
    </div>
  );
}
